import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { emptyFn } from '../../utils/helper';
import { FormItemContext } from '../Form/context';
import { consumeTheme } from '../../utils/theme';
var Input = (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.leftIconRef = React.createRef();
        _this.rightIconsRef = React.createRef();
        _this.state = {
            value: _this.props.defaultValue,
        };
        _this.handleChange = function (e) {
            if (_this.props.disabled) {
                return;
            }
            var value = e.target.value;
            _this.props.onChange(value, e);
            _this.setState({ value: value });
        };
        _this.preventLoseFocus = function (e) {
            e.preventDefault();
        };
        _this.handleClear = function () {
            _this.setState({ value: '' }, function () {
                _this.props.onChange('');
            });
        };
        _this.handleIconKeyDown = function (handler) { return function (e) {
            var disabled = _this.props.disabled;
            if (disabled || !handler) {
                return;
            }
            if ([' ', 'Enter'].includes(e.key)) {
                e.preventDefault();
                handler();
            }
        }; };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, disabled = _c.disabled, underline = _c.underline, icon = _c.icon, leftIcon = _c.leftIcon, onClickIcon = _c.onClickIcon, onClickLeftIcon = _c.onClickLeftIcon, onChange = _c.onChange, inputStyle = _c.inputStyle, showClear = _c.showClear, forcedValue = _c.value, defaultValue = _c.defaultValue, inputRef = _c.inputRef, inputClassName = _c.inputClassName, testId = _c.testId, errorTip = _c.errorTip, rest = __rest(_c, ["prefixCls", "className", "style", "disabled", "underline", "icon", "leftIcon", "onClickIcon", "onClickLeftIcon", "onChange", "inputStyle", "showClear", "value", "defaultValue", "inputRef", "inputClassName", "testId", "errorTip"]);
            var stateValue = _this.state.value;
            var status = _this.status;
            var value = typeof forcedValue === 'string' ? forcedValue : stateValue;
            var cls = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var inputCls = classNames(prefixCls + "-input", inputClassName, prefixCls + "-input-" + status, (_b = {}, _b[prefixCls + "-input-underline"] = underline, _b));
            var errorTipCls = classNames(prefixCls + "-error-text");
            var clearVisible = !!(value && !disabled);
            return (h("div", { className: cls, style: style, "data-testid": testId },
                _this.renderSingleIcon({
                    prop: leftIcon,
                    description: 'left',
                    handler: onClickLeftIcon,
                    ref: _this.leftIconRef
                }, classNames),
                h("input", __assign({ className: inputCls, style: __assign(__assign({}, _this.getIconPaddings()), inputStyle), onChange: _this.handleChange, value: value, disabled: disabled, ref: inputRef }, rest)),
                _this.renderRightIcons(clearVisible, classNames),
                errorTip && h("div", { className: errorTipCls }, errorTip)));
        };
        return _this;
    }
    Input.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    Object.defineProperty(Input.prototype, "status", {
        get: function () {
            if (this.props.errorTip) {
                return 'error';
            }
            return this.context.status;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.getIconPaddings = function () {
        var leftIconDom = this.leftIconRef.current;
        var rightIconsDom = this.rightIconsRef.current;
        var result = {};
        var gap = 2;
        if (leftIconDom) {
            result.paddingLeft = leftIconDom.getBoundingClientRect().width + gap + "px";
        }
        if (rightIconsDom) {
            result.paddingRight = rightIconsDom.getBoundingClientRect().width + gap + "px";
        }
        return result;
    };
    Input.prototype.renderSingleIcon = function (_a, classNames) {
        var _b;
        var prop = _a.prop, description = _a.description, handler = _a.handler, ref = _a.ref;
        var _c = this.props, prefixCls = _c.prefixCls, underline = _c.underline;
        var cls = classNames(prefixCls + "-icon", (_b = {},
            _b[prefixCls + "-icon-" + description] = description,
            _b[prefixCls + "-icon-clickable"] = handler,
            _b[prefixCls + "-icon-underline"] = underline,
            _b));
        return prop ?
            h("div", { className: cls, onMouseDown: this.preventLoseFocus, onClick: handler, ref: ref, tabIndex: handler ? 0 : -1, onKeyDown: handler ? this.handleIconKeyDown(handler) : undefined, role: "button" }, typeof prop === 'string' ?
                h("span", { className: classNames(prefixCls + "-icon-img"), style: { backgroundImage: "url(\"" + prop + "\")" } })
                : prop)
            : null;
    };
    Input.prototype.renderRightIcons = function (clearVisible, classNames) {
        var _a, _b;
        var _c = this.props, prefixCls = _c.prefixCls, showClear = _c.showClear, icon = _c.icon, onClickIcon = _c.onClickIcon, underline = _c.underline;
        var clearCls = classNames(prefixCls + "-clear", (_a = {},
            _a[prefixCls + "-clear-visible"] = clearVisible,
            _a[prefixCls + "-icon"] = !underline,
            _a[prefixCls + "-clear-underline"] = underline,
            _a));
        var containerCls = classNames(prefixCls + "-icon-container", (_b = {},
            _b[prefixCls + "-icon-container-underline"] = underline,
            _b));
        return (showClear || icon) ?
            h("div", { className: containerCls, ref: this.rightIconsRef },
                showClear ?
                    h("button", { className: clearCls, onMouseDown: this.preventLoseFocus, onClick: this.handleClear })
                    : null,
                this.renderSingleIcon({
                    prop: icon,
                    handler: onClickIcon
                }, classNames))
            : null;
    };
    Input.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Input.contextType = FormItemContext;
    return Input;
}(React.Component));
export default Input;
Input.defaultProps = {
    prefixCls: 'dui-input',
    onChange: emptyFn,
    showClear: false,
    defaultValue: ''
};
